'use client';

import { InputProps } from '@/components/auth/common/ModalInput';
import { forwardRef, useState } from 'react';
import iconPassword from '@/components/auth/assets/icon_password.png';
import EyeIcon from './ic-eye.svg';
import EyeLineThroughIcon from './ic-eye-line-through.svg';
import { ModalInput as Input } from '@/components/auth/common/index';
import Image from 'next/image';

export type PasswordInputProps = Omit<InputProps, 'type' | 'ref' | 'inputSuffix'>;

export default forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(props, ref) {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword((value) => !value);

  return (
    <Input
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      className="placeholder:text-[#CECED0] text-[13px] md:text-[20px]"
      errorClassName="text-left"
      inputPrefix={<Image src={iconPassword} alt="Password Icon" className="w-[40px] h-[40px]" />}
      inputSuffix={
        <button type="button" onClick={toggleShowPassword}>
          {showPassword ? (
            <EyeIcon className="w-[2rem]" />
          ) : (
            <EyeLineThroughIcon className="w-[2rem]" />
          )}
        </button>
      }
      {...props}
    />
  );
});
